import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../components/layout/MainLayout";
import HomePage from "../features/home/HomePage";
import NewsListPage from "../features/news/NewsListPage";
import EventsPage from "../features/events/EventsPage";
import EquipesPage from "../features/equipes/EquipesPage";
import RankingPage from "../pages/ranking/RankingPage";
import CalendarPage from "../pages/calendar/CalendarPage";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <MainLayout />,
        children: [
            { index: true, element: <HomePage /> },
            { path: "actualites", element: <NewsListPage /> },
            { path: "evenements", element: <EventsPage /> },
            { path: "calendrier", element: <CalendarPage /> },
            { path: "classement", element: <RankingPage /> },
            { path: "equipes", element: <EquipesPage /> },
        ],
    },
]);